import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useImperativeHandle, useRef } from "react";
import { CLEAR_WEATHER_SYMBOL } from "@poscon/shared-types";
import { useDispatch } from "react-redux";
import { eramFontDimensionMap, eramFontNameMap, getBitmapTextStyles } from "../../eramFont.js";
import { EramInput, useInputProps } from "./EramInput.js";
import { colorNameMap } from "../../colorNameMap.js";
import { setSelectedAdvisory } from "../slices/commonSlice.js";
import { EramPrompt } from "./EramPrompt.js";
import { useCenterCursor } from "../hooks/useCenterCursor.js";
import { stringToParsedTokenArray } from "@poscon/shared-types/eram";
export const advUplinkTemplateView = "ADV_UPLINK_TEMPLATE";
const fontFamily = eramFontNameMap[2];
const fontDim = eramFontDimensionMap[fontFamily];
export const advUplinkTemplateWidth = 30 * fontDim.width;
export const AdvUplinkTemplate = ({ dispatchCommand, adv, ref, ...promptProps }) => {
    const localRef = useRef(null);
    const dispatch = useDispatch();
    const inputProps = useInputProps(`${advUplinkTemplateView}/input`, "", (s) => {
        dispatchCommand(stringToParsedTokenArray(`UM /U ${adv.name}${CLEAR_WEATHER_SYMBOL} ${s}`));
        dispatch(setSelectedAdvisory(null));
    });
    useCenterCursor(localRef);
    useImperativeHandle(ref, () => {
        return localRef.current;
    }, []);
    return (_jsxs(EramPrompt, { ref: localRef, title: "UPLINK TEMPLATE", width: advUplinkTemplateWidth, height: fontDim.height * 2 + 9, closeMenu: () => {
            dispatch(setSelectedAdvisory(null));
        }, showX: true, ...promptProps, children: [_jsx("bitmapText", { x: 4, y: 4, text: "FLID", style: { ...getBitmapTextStyles(fontFamily), fill: colorNameMap.lightGrey } }), _jsx(EramInput, { x: fontDim.width * 5, y: 4, width: fontDim.width * 23, height: fontDim.height * 2 + 4, borderTint: colorNameMap.darkGrey, highlightColor: colorNameMap.white, ...inputProps })] }));
};
//# sourceMappingURL=AdvUplinkTemplate.js.map